// extracted by mini-css-extract-plugin
module.exports = {"loginwrapper":"Admin_loginwrapper__27fBL"};